import moment from 'moment';
import allStages from '../../components/stages';
import {
  stage as stageEnum,
  sortByDate,
  lineStatus,
  pathname,
} from '../../utils';
import { ILine } from '../../global';
import { IProduct } from '../../Types';
import { v4 as uuidv4 } from 'uuid';

export function getLinePageWidth(mobile: boolean) {
  return mobile ? 600 : 900;
}

export function isLinesOnboardingPage(page: string) {
  const lineOnboardingPages = [
    pathname.onboarding.main.lineExplained.url,
    pathname.onboarding.main.createFirstLine.url,
  ];
  return lineOnboardingPages.includes(page);
}

function onboardingStagesAmount(stageValue) {
  switch (stageValue) {
    case stageEnum.inventoryDeposit.value:
      return 10000;
    case stageEnum.remainingBalance.value:
      return 30000;
    case stageEnum.freight.value:
      return 4000;
    case stageEnum['3pl'].value:
      return 3000;
    case stageEnum.marketing.value:
      return 2000;
    default:
      return null;
  }
}

export function createOnboardingLine(
  lineId: string,
  newestProduct: IProduct,
  lineName: string,
  edit: boolean = false,
  exampleLine: boolean = true,
) {
  let stages = allStages
    .filter((stage, i) => i < 6)
    .map((stage, i) => {
      const isStockOnHand = stage.value === stageEnum.sellingStart.value;
      return {
        line: lineId,
        id: uuidv4(),
        name: stage.value,
        amount: exampleLine ? onboardingStagesAmount(stage.value) : null,
        start:
          stage.value === stageEnum.sellingStart.value
            ? moment().startOf('month').add(5, 'months').format('YYYY-MM-DD')
            : moment()
                .startOf('month')
                .add(1, 'month')
                .add(i * 1, 'months')
                .format('YYYY-MM-DD'),
        deleted: false,
        needsDateChange: isStockOnHand,
      };
    });
  stages = sortByDate(stages);
  const newLine: ILine = {
    id: lineId,
    edit: edit,
    new: true,
    name: lineName,
    status: lineStatus.draft,
    product: newestProduct?.id,
    inventory: newestProduct?.nextBatch,
    stages,
  };

  return newLine;
}

export function isUserInInitialOnboarding(
  products: Array<IProduct>,
  lines: Array<ILine>,
) {
  const filteredLines = lines?.filter((line) => !line.edit && !line.new);
  if (products?.length === 1 && filteredLines?.length < 3) {
    return true;
  } else {
    return false;
  }
}
